import { cn } from '@/lib/utils'

export default function GridToolbarContainer({
    children,
    className,
    hidden = false,
}: {
    children: React.ReactNode
    className?: string
    hidden?: boolean
}) {
    if (hidden) return null
    return (
        <div
            className={cn(
                'flex justify-between items-center p-1 px-2 flex-wrap',
                'min-h-[3.5rem] h-fit',
                'border-x border-t bg-inherit border-inherit',
                'rounded-t-md rounded-b-none',
                className,
            )}
        >
            {children}
        </div>
    )
}
